import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { CriticZone } from 'src/app/core/interfaces/critic-zone';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { PlanningRouteService } from 'src/app/core/services/planning-route.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CriticZonesFormComponent } from './critic-zones-form/critic-zones-form.component';

@Component({
  selector: 'app-critic-zones',
  templateUrl: './critic-zones.component.html',
  styleUrls: ['./critic-zones.component.scss']
})
export class CriticZonesComponent implements OnInit {
  permission = Permission;
  public zones: CriticZone[] = [];

  constructor(
    private matDialog: MatDialog,
    private planningRouteService: PlanningRouteService,
    private snackbarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private permissionRole: PermissionRole,
  ) { }

  ngOnInit() {
    this.loadList();
  }

  public create() {
    this.openForm({ mode: 'create' });
  }

  public view(zone: CriticZone) {
    this.openForm({ zone, mode: 'view' });
  }

  public edit(zone: CriticZone) {
    this.openForm({ zone, mode: 'edit' });
  }

  private openForm(data: { zone?: CriticZone, mode: 'create' | 'edit' | 'view' }) {
    const config = new MatDialogConfig();
    config.data = data;
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.LARGE_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    this.matDialog.open(CriticZonesFormComponent, config).afterClosed().subscribe(result => {
      if (result && result.state) {
        this.loadList();
      }
    });
  }

  loadList() {
    this.spinner.show();
    this.planningRouteService.getCriticZones().subscribe(
      (result: CriticZone[]) => {
        this.spinner.hide();
        this.zones = result ? result : [];
      }, () => {
        this.spinner.hide();
        this.zones = [];
      }
    );
  }

  getPointLabel(point: { name?: string, alias?: string }): string {
    if (!point) return '';
    if (point.alias) return point.alias;
    return point.name || '-';
  }

  get hasPermissionEdit(): boolean {
    return this.permissionRole.hasPermission(this.permission.routes.module, this.permission.routes.editCriticZones);
  }
}
